import {
  getLinkedServices,
  SERVICES,
  getServiceStateName,
  SERVICE_ITEM_STATES,
  getServiceName,
  Services,
  getLinkedArtworkServices,
} from '@printdeal/business-logic';
import Order from '../types/order/Order';
import { Environment } from './env';

export const getDesignServiceLineItem = (lineItemId: string, order: Order) => {
  const linkedServices = getLinkedServices(lineItemId, order);
  return linkedServices.find((linkedService) => linkedService.custom?.fields?.serviceName === SERVICES.FILE_DESIGN);
};

export const getChangeServiceLineItem = (lineItemId: string, order: Order) => {
  const linkedServices = getLinkedServices(lineItemId, order);
  return linkedServices.find((linkedService) => linkedService.custom?.fields?.serviceName === SERVICES.FILE_CHANGE);
};

export const hasSubmittedServiceRequestDetails = (
  lineItemId: string,
  order: Order,
  serviceName: Services,
) => {
  const linkedArtworkServices = getLinkedArtworkServices(lineItemId, order);
  const linkedServiceForType = linkedArtworkServices
    .filter((service) => getServiceName(service) === serviceName);

  if (linkedServiceForType.length === 0) {
    return false;
  }

  // Even if lineItems might eventually have multiple linkedArtworkServices,...
  // ... they should have multiple linkedArtworkServices of the same 'serviceName', so we can use [0].
  const serviceStatus = getServiceStateName(linkedServiceForType[0], Environment);

  const ALLOWED_STATES: string[] = [
    SERVICE_ITEM_STATES.EDIT_IN_PROGRESS,
    SERVICE_ITEM_STATES.SERVICE_IN_PROGRESS,
    SERVICE_ITEM_STATES.SERVICE_DELIVERED,
  ];

  return serviceStatus ? ALLOWED_STATES.includes(serviceStatus) : false;
};
